// Image configuration and paths
export const imageConfig = {
  // Hero section images
  hero: {
    londonSkyline: '/images/hero/london-skyline-hero.webp',
    aiTransformation: '/images/hero/ai-transformation-hero.webp',
    businessMeeting: '/images/hero/business-meeting-hero.webp',
    technologyAbstract: '/images/hero/technology-abstract.webp',
    servicesHero: '/images/hero/services-hero.webp',
    aiRobot: '/images/hero/ai-robot.jpg'
  },
  
  // Services section images
  services: {
    aiStrategy: '/images/services/ai-strategy.webp',
    digitalTransformation: '/images/services/digital-transformation.webp',
    digitalStrategy: '/images/services/digital-strategy.webp',
    changeManagement: '/images/services/change-management.webp',
    dataAnalytics: '/images/services/data-analytics.webp',
    analyticsDashboard: '/images/services/analytics-dashboard.webp',
    cloudComputing: '/images/services/cloud-computing.webp',
    processOptimization: '/images/services/process-optimization.webp',
    qualityAssurance: '/images/services/quality-assurance.webp',
    transformationAssurance: '/images/services/transformation-assurance.webp',
    enterpriseSolutions: '/images/services/enterprise-solutions.webp',
    cloudTransformation: '/images/services/cloud-transformation.webp',
    // Alternative images to resolve duplicates
    changeManagementAlt: '/images/technology/predictive-analytics.webp',
    processOptimizationAlt: '/images/technology/automation.webp',
    cloudComputingAlt: '/images/technology/machine-learning.webp',
    digitalTransformationAlt: '/images/technology/nlp-processing.webp'
  },
  
  // About section images
  about: {
    principalConsultant: '/images/about/armando.webp',
    consultantProfile: '/images/about/consultant-profile.webp',
    teamMember: '/images/about/team-member.webp',
    leadershipProfile: '/images/about/leadership-profile.webp',
    consultingTeam: '/images/about/consulting-team.webp',
    // Leadership roles - fixing duplicates and bad crops
    digitalStrategyLeader: '/images/about/consultant-profile.webp',
    aiStrategyConsultant: '/images/about/leadership-profile-face-visible.webp',
    changeManagementExpert: '/images/about/team-member-full-face.jpg',
    cloudInfrastructureLead: '/images/about/team-member-full-face.jpg',
    processOptimizationManager: '/images/about/consulting-team.webp',
    aiTransformationCoach: '/images/about/consulting-team.webp',
    transformationAdvisor: '/images/clients/consulting-services.webp'
  },
  
  // Technology section images
  technology: {
    machineLearning: '/images/technology/machine-learning.webp',
    automation: '/images/technology/automation.webp',
    nlpProcessing: '/images/technology/nlp-processing.webp',
    dataVisualization: '/images/technology/data-visualization.webp',
    predictiveAnalytics: '/images/technology/predictive-analytics.webp',
    artificialIntelligence: '/images/technology/nlp-processing.webp',  // Added missing AI image
    delivery: '/images/technology/delivery.webp',  // Added delivery image
    nextGenerationComputing: '/images/technology/next-generation-computing.webp',
    purposefulInnovation: '/images/technology/purposeful-innovation.webp',
    scienceTech: '/images/technology/science-tech.webp',
    aiDrivenAutomation: '/images/technology/ai-driven-automation.webp',
    aiImplementation: '/images/technology/ai-implementation.webp'
  },
  
  // Client/Industry images - Each section gets UNIQUE image (8 sections, 8 different files)
  clients: {
    retailBanking: '/images/clients/london-skyline-financial.webp',         // 1. Financial skyline for retail banking
    corporateBanking: '/images/clients/financial-growth.webp',              // 2. Growth chart for corporate banking  
    assetManagement: '/images/clients/assets.jpeg',                         // 3. Dedicated assets image for asset management
    insurance: '/images/clients/flooding.webp',                             // 4. Flooding image - perfect for insurance sector
    publicSector: '/images/clients/government-sector.webp',                 // 5. Government building for public sector
    software: '/images/clients/software.jpg',                               // 6. Dedicated software image for software sector
    managementConsulting: '/images/placeholder-image.webp',        // 7. Image placeholder for management consulting
    energySector: '/images/clients/energy-sector.avif'                      // 8. Energy specific image
  },
  
  // Background images
  backgrounds: {
    gradientDark: '/images/backgrounds/gradient-bg-dark.webp',
    londonBlur: '/images/backgrounds/london-blur.webp',
    techPattern: '/images/backgrounds/tech-pattern.webp'
  },
  
  // Content/YouTube images
  content: {
    videoAi: '/images/content/video-thumbnail-ai.webp',
    videoChange: '/images/content/video-thumbnail-change.webp',
    videoCloud: '/images/content/video-thumbnail-cloud.webp',
    channelArt: '/images/content/youtube-channel-art.webp',
    youtubeModernising: '/images/content/YouTubeModernising.webp',
    youtubeAIAssistants: '/images/content/YouTubeAIAssistants.webp',
    youtubeRAG: '/images/content/YouTubeRAG.webp',
    youtubeWillAI: '/images/content/YouTubeWillAI.webp',
    YouTubeAIAssistants: '/images/content/YouTubeAIAssistants.webp',
    YouTubeRAG: '/images/content/YouTubeRAG.webp',
    YouTubeWillAI: '/images/content/YouTubeWillAI.webp'
  }
};

// Image optimization settings
export const imageOptimization = {
  quality: 80,
  formats: ['webp', 'avif', 'jpg'],
  sizes: {
    hero: { width: 1200, height: 675 }, // Optimized 16:9 ratio
    service: { width: 600, height: 450 }, // Reduced for performance
    about: { width: 400, height: 400 }, // Square profiles
    technology: { width: 500, height: 300 }, // Optimized ratio
    client: { width: 350, height: 250 }, // Compact display
    thumbnail: { width: 280, height: 157 }, // 16:9 YouTube standard
    content: { width: 400, height: 225 }, // 16:9 content
    background: { width: 1200, height: 675 } // Reduced background size
  }
};

// Alt text templates
export const altTexts = {
  hero: {
    londonSkyline: "Modern London skyline representing Saner Consulting's UK headquarters",
    aiTransformation: "Abstract AI transformation visualization showing digital innovation",
    businessMeeting: "Professional business consultation meeting with Saner Consulting team",
    technologyAbstract: "Modern technology and digital transformation concept",
    servicesHero: "Professional services and business transformation solutions"
  },
  
  services: {
    aiStrategy: "AI strategy implementation and machine learning solutions",
    digitalTransformation: "Digital transformation and modernization services",
    digitalStrategy: "Digital strategy and technology roadmap planning",
    changeManagement: "Change management and organizational transformation",
    dataAnalytics: "Data analytics and business intelligence solutions",
    analyticsDashboard: "Business analytics dashboard and performance metrics",
    cloudComputing: "Cloud computing and infrastructure modernization",
    processOptimization: "Business process optimization and efficiency improvements",
    qualityAssurance: "Quality assurance and compliance management services",
    transformationAssurance: "Transformation assurance and oversight services",
    enterpriseSolutions: "Enterprise solutions for large and small businesses",
    cloudTransformation: "Cloud transformation and data migration solutions"
  },
  
  about: {
    principalConsultant: "Principal Consultant at Saner Consulting",
    consultantProfile: "Professional consultant expertise and leadership",
    teamMember: "Experienced team member and industry expert",
    leadershipProfile: "Senior leadership and strategic advisory role",
    consultingTeam: "Professional consulting team collaboration",
    digitalStrategyLeader: "Digital Strategy Leadership Team Member",
    aiStrategyConsultant: "AI Strategy Consultant Profile",
    changeManagementExpert: "Change Management Expert Profile",
    cloudInfrastructureLead: "Cloud Infrastructure Lead Profile",
    processOptimizationManager: "Process Optimization Manager Profile",
    aiTransformationCoach: "AI Transformation Coach and Consulting Expert",
    transformationAdvisor: "Transformation Advisor and Strategic Consultant"
  },
  
  technology: {
    machineLearning: "Machine learning algorithms and neural network visualization",
    automation: "Robotic process automation and intelligent systems",
    nlpProcessing: "Natural language processing and AI communication",
    dataVisualization: "Data visualization and business intelligence dashboards",
    computerVision: "Computer vision and image recognition technology",
    predictiveAnalytics: "Predictive analytics and data modeling solutions",
    nextGenerationComputing: "Next-generation computing and advanced technology solutions",
    purposefulInnovation: "Innovation strategy and purposeful technology development",
    scienceTech: "Science and technology solutions for social impact",
    aiDrivenAutomation: "AI-driven automation and intelligent process transformation",
    aiImplementation: "AI implementation and enterprise deployment solutions"
  },
  
  clients: {
    financialServices: "Financial services sector digital transformation",
    financialGrowth: "Financial growth and investment strategy solutions",
    publicSector: "Government and public sector digital transformation services",
    assetManagement: "Asset management and investment portfolio solutions",
    technologyConsulting: "Technology consulting and professional services",
    financialMarkets: "Energy sector and financial markets expertise",
    energySector: "Oil, gas and energy sector transformation"
  },
  
  content: {
    videoAi: "AI transformation video content",
    videoChange: "Change management best practices video",
    videoCloud: "Cloud migration strategy guide",
    channelArt: "Saner Consulting YouTube channel art",
    youtubeModernising: "Modernising Business Transformation with AI video thumbnail",
    youtubeAIAssistants: "AI Assistants for Change Managers video thumbnail",
    youtubeRAG: "RAG for Change Management video thumbnail",
    youtubeWillAI: "Will AI Replace Change Experts video thumbnail"
  }
};